import { useRef, useEffect, useMemo } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../../utils/DataRefresher";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Controller, useFieldArray } from "react-hook-form";
import { ServiceCard } from "./ServiceCard";
import "primeicons/primeicons.css";
import { Panel } from "primereact/panel";
import { MultiSelect } from "primereact/multiselect";

// import { RenderCounter } from "./UtilityComponets";

export default function Services({
  panelClasses,
  panelState,
  onExpand,
  clientType,
  formSetValue,
  lists,
  control,
  getValues,
  watch,
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "services",
  });

  const authToken = useSelector((state) => state.user.bearer);
  const apiRoot = useSelector(state => state.globals.apiRoot);
  const [serviceTypes, setServiceTypes] = useState([]);

  useEffect(() => {
    console.log("Loading Services");
    fetch(`${apiRoot}/api/services`,{
      method: "GET",
      mode: "cors",
      headers: { authorization: authToken },
    }).then((resp) => resp.json()).then((data) => setServiceTypes(data));

  }, [authToken, apiRoot]);
  // const serviceTypes = useLiveQuery(async () => {
  //   let typeData = null;
  //   if (clientType === "IND") {
  //     typeData = await db.SERVICES.where("SERVPERSON")
  //       .equalsIgnoreCase("true")
  //       .sortBy("SERVNAME");
  //   } else if (clientType === "ORG") {
  //     typeData = await db.SERVICES.where("SERVORGANISATION")
  //       .equalsIgnoreCase("true")
  //       .sortBy("SERVNAME");
  //   }

  //   return typeData;
  // }, [clientType]);

  const ref = useRef(null);
  useEffect(() => {
    if (panelState === true) {
      ref.current.expand();
    } else if (panelState === false) {
      ref.current.collapse();
    }
  }, [panelState]);

  const mapServices = useMemo(() => (item, index) => {
    return (
      <ServiceCard
        key={item.id}
        control={control}
        field={item}
        index={index}
        lists={lists}
        remove={remove}
        formSetValue={formSetValue}
        getValues={getValues}
        watch={watch}
      />
    )
  }, [control, lists, remove, watch, getValues, formSetValue])

  let serviceCards = fields.map(mapServices)

  // Function to handle changes in the array of services
  const arrayChange = (newArray, curArray) => {

    // If the current array is not defined, append the new array
    if (!curArray) {
      append(newArray);

    // If the new array is longer than the current array, append the last item of the new array
    } else if (newArray.length > curArray.length) {

    // If the new array is shorter than the current array, remove items that are not in the new array
      append(newArray.slice(-1));

    } else if (newArray.length < curArray.length) {
      // The logic here handles the case when the new array is shorter than the current array.
      // It first maps the new array to extract the service codes (SERVCODE) into a newIds array.
      // Then, it iterates over the current array and removes any items whose service code is not present in the newIds array.
      // This ensures that the current array only contains items that are also present in the new array.
      const newIds = newArray.map((item) => item.SERVCODE);
      curArray.forEach((item, index) => {

        // Remove items from the current array that are not in the new array
        if (!newIds.includes(item.SERVCODE)) {
          remove(index);
        }

      });
    }
  };

  const selectedService = watch("ServiceSelection");

  return (
    <Panel
      header={<span className="ncto-panel-title">Services and Jobs</span>}
      pt={{ content: { className: panelClasses } }}
      className="justify-content-center"
      ref={ref}
      toggleable
      onExpand={onExpand}
    >
      <div
        id="contact-search"
        className="w-full px-1 align-self-end flex flex-wrap justify-content-center"
      >
        <h6 className="w-full text-center">
          <label>Select Services</label>
        </h6>
        {serviceTypes && (
          <Controller
            name="ServiceSelection"
            control={control}
            defaultValue={[]}
            rules={{ required: "Contact First Name Required." }}
            render={({ field }) => (
              <MultiSelect
                id={field.name}
                placeholder="Services To Add To Client"
                value={selectedService}
                onChange={(e) => {
                  field.onChange(e.value);
                  arrayChange(e.value, selectedService);
                }}
                options={serviceTypes}
                optionLabel="SERVNAME"
                className="w-10"
                display="chip"
              />
            )}
          />
        )}
      </div>
      <section className="flex flex-wrap w-full justify-content-center">
        {serviceCards}
      </section>
    </Panel>
  );
}
